import { Button } from "@features/atoms/Button"
import { CartPanel } from "@features/tickets/CartPanel"
import { useCheckout } from "@features/tickets/useCheckout"
import { cn } from "@utils/tw"
import { useFlyingCarpet } from "./flying-carpet"

export function CartCarpetPage() {
  const checkout = useCheckout()
  const carpet = useFlyingCarpet()
  const isEmpty = !checkout.basket?.tickets.length && !checkout.basket?.membershipSubscriptions.length

  return (
    <div className="h-full min-h-0 relative flex flex-col">
      <div className={cn("flex-1 min-h-0 px-grid-margin md:px-4", isEmpty && "pb-grid-margin md:pb-4")}>
        <CartPanel />
      </div>
      {!isEmpty && (
        <div className="p-grid-margin md:p-4 flex pt-0 md:pt-0 shrink-0 items-center gap-4">
          <Button href="/films" variant="outline" className="flex-1">
            Add Another Film
          </Button>
          <Button
            variant="filled"
            onClick={() => {
              carpet.close()
              checkout.openCheckout()
            }}
            className="flex-1"
            loading={checkout.isPending}
          >
            Checkout Now
          </Button>
        </div>
      )}
    </div>
  )
}
